import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Axios from "axios";
import DatePicker from "react-datepicker";
import Select from "react-select-virtualized";
import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBIcon,
  MDBModal,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBCardFooter,
  MDBBtn,
  MDBBtnGroup,
  MDBTooltip,
} from "mdbreact";
import { toast, ToastContainer } from "react-toastify";

import "../css/scrollbar.css";

import AccessDenied from "../components/AccessDenied";

import AddEditSalesMain from "./AddEditSalesMain";

import Sales from "./Sales";
import { setDate } from "date-fns/esm";
import SalesHistory from "./SalesHistory";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faWarning } from "@fortawesome/free-solid-svg-icons";
import Charges from "./Charges";
import { useDispatch } from "react-redux";
import {
  setCustomerTicket,
  setStatus,
  setTransactionDate,
} from "../features/sales/salesSlice";

const OpenTransactions = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const dispatch = useDispatch();
  var date = new Date();

  const [frm, setValues] = useState({
    // DateFrom:new Date(date.getFullYear(),date.getMonth() ,1)
    DateFrom: new Date(),
    DateTo: new Date(),
    useFilter: true,
    deleted: false,
    requesttype: { value: "147", label: "MEDICAL" },
  });

  // const [frm, setValues] = useState({
  //   code:''
  //   ,deliveredby:''
  //   ,paid:false
  //   ,usercode:sessionStorage.getItem("msal.uc")
  // });

  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;
      setValues({ ...frm, [name]: value });
    } else {
      setValues({ ...frm, [name]: value });
    }
  };

  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(1);
  const [showPreloader, setPreloader] = useState("normal");
  const [strTransactions, setTransactions] = useState("");
  const [selRow, setSelectedRow] = useState("");

  const [modalAddEdit, showAddEdit] = useState(false);

  const toggleAddEdit = (transtype) => {
    setRows([]);

    showAddEdit(!modalAddEdit);

    loadData();
  };

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const toastId = React.useRef(null);

  const notify = (message) => {
    toastId.current = toast.info(message);
  };

  const [dateToday, setDateToday] = useState(String(new Date()));
  const [bRefresh, setRefresh] = useState(false);

  const refreshGrid = (message) => {
    setRows([]);
    setRefresh(!bRefresh);

    loadData();
    notify(message);
  };

  const showResult = (message) => {
    setRefresh(!bRefresh);

    setRows([]);

    // loadData();

    loadData();

    toast.info(message, {
      closeButton: false,
    });
  };

  function loadData() {
    Axios.get(
      props.apiServer +
        "/transactionsmainlist?DateFrom=" +
        frm.DateFrom.toDateString() +
        "&DateTo=" +
        frm.DateTo.toDateString() +
        "&token=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        setRows(res.data);
        setRowCount(1);
        setRowCount(res.data.length);

        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  function ShowDeleted() {
    setTransactions("");
    setPreloader("normal");
    setTransactions("deleted");
    loadData();
  }

  const [errorMessage, setErrorMessage] = useState("");

  const getDateValue = (dtPickerName) => (actualValue) => {
    setValues({ ...frm, [dtPickerName]: actualValue });
  };

  function ShowReturns() {
    setTransactions("");
    setPreloader("normal");
    setTransactions("returns");
    loadData();
  }

  function ShowSalesMain() {
    setTransactions("");
    setPreloader("normal");
    setTransactions("SalesMain");
    loadData();
  }

  function ShowAll() {
    setPreloader("normal");
    setTransactions("");
    loadData();
  }
  const useMountEffect = (functionName) => useEffect(functionName, []);

  function ObtainDate() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();
    today = mm + "/" + dd + "/" + yyyy;
    setDateToday(today);
  }

  function UpdateTableData(code, fieldName, newValue) {
    const data = {
      code: code,
      fieldName: fieldName,

      actualValue: newValue,
      usercode: sessionStorage.getItem("msal.uc"),
    };
    // console.log(data);
    Axios.post(props.apiServer + "/savesalesmaintabledata", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          ShowAll();
          ShowSalesMain();
        } else {
          toast.warning(res.data.message, {
            closeButton: false,
          });

          console.log(res.data.message);
        }
      })
      .catch((error) => {
        console.log("error");
      });
  }

  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    loadData();
  }

  function openthistransaction(x) {
    // alert(x);
    Axios.get(props.apiServer + "/openthistransaction?code=" + x, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          props.ClearFields();
          setValues({ ...frm, code: res.data.code });
          //update state
          dispatch(setCustomerTicket(res.data.code));
          dispatch(setTransactionDate(res.data.transactiondate));
          dispatch(setStatus(res.data.printed));
          console.log(res.data.printed);
          // dispatch(setDiscountType(res.data.discount));
          // dispatch(setDiscountCode(res.data.discountcode));
          // dispatch(setDiscountRate(res.data.discountrate));

          // props.settransactioncode(res.data.code);
          // props.settransactiondate(res.data.transactiondate);
          // props.setdiscount(res.data.discount);
          // props.setdiscountcode(res.data.discountcode);
          // props.setdiscountrate(res.data.discountrate);
          // props.setdiscount(res.data.discount);
          props.toggleModal();
          // props.refreshGrid(res.data.message);
        } else {
          toast.warning(res.data.message, {
            closeButton: false,
          });

          setErrorMessage(res.data.message);
          toggleWarningBox();
          console.log(res.data.message);
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });

    //  loadtransactionsalesmain();
  }

  const RowData = (props) => {
    return (
      <>
        {" "}
        {props.printed === "Invoice Printed" ? (
          <>
            <span>{props.rowData}</span>
          </>
        ) : (
          <>
            <span className="red-text font-weight-bold">{props.rowData}</span>
          </>
        )}
      </>
    );
  };
  // useMountEffect(loadData);
  useMountEffect(ObtainDate);

  useEffect(() => {
    loadData();
  }, [strTransactions, frm]);

  return (
    <React.Fragment>
      <form className="needs-validation" onSubmit={submitHandler} noValidate>
        <MDBRow>
          <MDBCol md="12">
            {showPreloader === "normal" ? (
              <MDBRow>
                <MDBCol md="4"></MDBCol>
                <MDBCol md="4" className="text-center">
                  <br />
                  <img
                    src={props.deployURL + "/loading.gif"}
                    style={{ width: "300px", textAlign: "center" }}
                    alt="loading"
                  />
                  <br />
                </MDBCol>
                <MDBCol md="4"></MDBCol>
              </MDBRow>
            ) : (
              <React.Fragment>
                <MDBRow>
                  <MDBCol md="8">
                    <h6
                      style={{ fontFamily: "Montserrat", fontWeight: "400" }}
                      className="display-5 blue-grey-text ml-1"
                    >
                      {" "}
                      TRANSACTIONS
                    </h6>
                  </MDBCol>
                  <MDBCol md="4"></MDBCol>
                </MDBRow>

                <MDBRow>
                  <MDBCol md="2" className="text-left">
                    <label className="grey-text">
                      <small>&nbsp;Date From</small>
                    </label>
                  </MDBCol>
                  <MDBCol md="2" className="text-left">
                    <label className="grey-text">
                      <small>&nbsp;Date To</small>
                    </label>
                  </MDBCol>

                  <MDBCol md="2" className="text-left"></MDBCol>
                </MDBRow>
                <MDBRow className="d-flex flex-row">
                  <MDBCol md="2" className="text-left">
                    <DatePicker
                      selected={frm.DateFrom}
                      onChange={getDateValue("DateFrom")}
                    />
                  </MDBCol>

                  <MDBCol md="2" className="text-left">
                    <DatePicker
                      selected={frm.DateTo}
                      onChange={getDateValue("DateTo")}
                    />
                  </MDBCol>

                  <MDBCol md="4" className="text-left">
                    <MDBBtnGroup>
                      {/* <MDBBtn  className="mb-5" color="primary" type="button" title="Add Customer Ticket"  onClick={toggleAddEdit}>
                                  <MDBIcon icon="plus" size="2x" className="pr-2" />
                             
                                </MDBBtn> */}
                      <MDBBtn
                        className="mb-5"
                        color="primary"
                        type="submit"
                        title="Refresh"
                      >
                        <MDBIcon icon="sync-alt" size="2x" className="pr-2" />
                      </MDBBtn>
                      <MDBBtn
                        className="mb-5 cloudy-knoxville-gradient brown-text"
                        type="button"
                        title="Close"
                        onClick={props.toggleModal}
                      >
                        <MDBIcon icon="times" size="2x" className="pr-2" />
                      </MDBBtn>
                    </MDBBtnGroup>
                  </MDBCol>
                </MDBRow>

                <MaterialTable
                  title=""
                  cellEditable={{
                    onCellEditApproved: (
                      newValue,
                      oldValue,
                      rowData,
                      columnDef
                    ) => {
                      return new Promise((resolve, reject) => {
                        UpdateTableData(rowData.code, "showornumber", newValue);
                        setTimeout(resolve, 1000);
                      });
                    },
                  }}
                  columns={[
                    // [orcustomername],[plateno],[conductionsticker],carmake,variant,yearmodel
                    {
                      title: "Date/Time",
                      field: "transactiondatetimetext",
                      editable: "never",
                      export: true,
                      render: (rowData) => {
                        return (
                          <RowData
                            printed={rowData.printed}
                            rowData={rowData.transactiondatetimetext}
                          />
                        );
                      },
                    },
                    {
                      title: "Show OR",
                      field: "showornumber",
                      filtering: false,
                      type: "boolean",
                      export: false,
                    },
                    {
                      title: "OR Number",
                      field: "ornumber",
                      editable: "never",
                      export: true,
                    },
                    {
                      title: "SI Number",
                      field: "sinumber",
                      editable: "never",
                      export: false,
                    },
                    {
                      title: "Ticket Number",
                      field: "code",
                      editable: "never",
                      export: false,
                    },
                    {
                      title: "Name of Client",
                      field: "orcustomername",
                      editable: "never",
                      export: true,
                      // render: (rowData) => {
                      //   return (
                      //     <RowData
                      //       printed={rowData.printed}
                      //       rowData={rowData.orcustomername}
                      //     />
                      //   );
                      // },
                    },

                    {
                      title: "Vehicle",
                      field: "VehicleModel",
                      editable: "never",
                      export: true,
                    },
                    {
                      title: "Model",
                      field: "yearmodel",
                      hidden: true,
                      searchable: true,
                      editable: "never",
                    },
                    {
                      title: "Variant",
                      field: "variant",
                      hidden: true,
                      searchable: true,
                      editable: "never",
                    },
                    {
                      title: "Plate No",
                      field: "plateno",
                      hidden: true,
                      searchable: true,
                      editable: "never",
                    },
                    {
                      title: "Conduction Sticker",
                      field: "conductionsticker",
                      hidden: true,
                      searchable: true,
                      editable: "never",
                    },
                    {
                      title: "Mobile Number",
                      field: "mobilenumber",
                      editable: "never",
                    },
                    {
                      title: "Address",
                      field: "address",
                      editable: "never",
                      export: true,
                    },
                    {
                      title: "ODO",
                      field: "mileage",
                      editable: "never",
                      export: true,
                    },
                    {
                      title: "ODO + Next PMS",
                      field: "odofuture",
                      editable: "never",
                      export: true,
                    },
                    {
                      title: "Plate No",
                      field: "plateno",
                      editable: "never",
                      hidden: true,
                      searchable: true,
                      editable: "never",
                    },
                    {
                      title: "Conduction Sticker",
                      field: "conductionsticker",
                      editable: "never",
                      hidden: true,
                      searchable: true,
                      editable: "never",
                    },

                    {
                      title: "Printed",
                      field: "printed",
                      editable: "never",
                      hidden: true,
                      searchable: true,
                    },
                    {
                      title: "Services & Items Used",
                      field: "servicesrendered",
                      editable: "never",
                      filtering: false,
                      export: true,
                    },

                    {
                      title: "Total Price",
                      field: "totalsales",
                      editable: "never",
                      export: true,
                      // hidden: true,
                    },

                    {
                      title: "Payments",
                      field: "payments",
                      filtering: false,
                      editable: "never",
                      export: true,
                      // hidden: true,
                    },
                    {
                      title: "Amount To Pay",
                      field: "amounttopay",
                      editable: "never",
                      export: true,
                    },
                  ]}
                  data={rows}
                  options={{
                    search: true,

                    filtering: true,

                    pageSizeOptions: [10, 25, 50, 75, 100],
                    pageSize: 10,
                    exportButton: true,
                  }}
                  actions={[
                    {
                      icon: () => (
                        <MDBIcon icon="folder-open" className="blue-text" />
                      ),
                      tooltip: "Open This Transaction",
                      onClick: (event, rowData) =>
                        openthistransaction(rowData.code),
                    },
                  ]}
                  detailPanel={[
                    {
                      icon: () => <MDBIcon icon="list" className="blue-text" />,
                      openIcon: () => (
                        <MDBIcon
                          icon="chevron-circle-down"
                          className="red-text"
                        />
                      ),
                      tooltip: "Summary of Charges",
                      render: (rowData) => {
                        return (
                          <>
                            <MDBContainer fluid className="p-0 m-0">
                              <Charges
                                deployURL={props.deployURL}
                                apiServer={props.apiServer}
                                parentcode={rowData.code}
                                apiServerHybrid={props.apiServerHybrid}
                                apiServerPOS={props.apiServerPOS}
                              ></Charges>
                            </MDBContainer>
                          </>
                        );
                      },
                    },
                  ]}
                  // detailPanel={[

                  // {
                  //   icon: ()=> <MDBIcon icon="list" className="blue-text" />,
                  //   openIcon: ()=><MDBIcon icon="chevron-circle-down"  className="red-text" />,
                  //   tooltip:"Sales Details",
                  //   render: rowData => {
                  //   return (

                  //     <MDBContainer  className="ml-0" >
                  //         <MDBCardHeader className="cloudy-knoxville-gradient">
                  //         <span className="font-weight-bold"> SALES DETAILS &nbsp; <span className="blue-text">{rowData.code}</span>
                  //           </span>
                  //       </MDBCardHeader>

                  //         <SalesHistory
                  //          deployURL={props.deployURL}
                  //          apiServer={props.apiServer}
                  //          code={rowData.code }
                  //          dealercode={rowData.dealercode}
                  //          parentcode={rowData.code}
                  //          apiServerHybrid={props.apiServerHybrid}
                  //          discountcode={rowData.discountcode}
                  //          discounttype={rowData.discount}
                  //          discountrate={rowData.discountrate}

                  //           toggleModal={toggleAddEdit}
                  //          refreshGrid={refreshGrid}
                  //         showResult={showResult}
                  //         >

                  //         </SalesHistory>

                  //        <MDBCardFooter >

                  //        </MDBCardFooter>

                  //      </MDBContainer>

                  //   )
                  //   }

                  //   }

                  // ,
                  // {
                  //   icon: ()=> <MDBIcon icon="print" className="blue-text" />,
                  //   openIcon: ()=><MDBIcon icon="caret-down" className="black-text" />,
                  //   tooltip: 'Print Invoice',
                  //   render: rowData => {

                  //     return (

                  //         <React.Fragment>
                  //         <MDBCardHeader className="cloudy-knoxville-gradient black-text font-weight-bold">
                  //          Print Invoice &nbsp; &nbsp;
                  //          <MDBTooltip
                  //           domElement
                  //           tag="a"
                  //           placement="top"

                  //         >
                  //          <a href={props.apiServerHybrid + "/Print/PrintPreview?reporttype=invoice&code=" + rowData.code} rel="noopener noreferrer" target="_blank" ><MDBIcon icon="external-link-alt" /></a>

                  //           <span>Maximize and print in new window.</span>
                  //         </MDBTooltip>

                  //       </MDBCardHeader>

                  //       <div className="embed-responsive embed-responsive-16by9">
                  //         <iframe title="frmInvoice" className="embed-responsive-item" src={props.apiServerHybrid + "/Print/PrintPreview?reporttype=invoice&code=" + rowData.code} allowFullScreen scrolling={true}></iframe>

                  //       </div>

                  //       <MDBCardFooter>

                  //       </MDBCardFooter>

                  //       </React.Fragment>
                  //     )

                  //   }

                  // }

                  // ]}
                />
              </React.Fragment>
            )}
          </MDBCol>
        </MDBRow>

        <MDBModal
          backdrop={false}
          isOpen={modalAddEdit}
          toggleModal={toggleAddEdit}
          fullHeight
          position="right"
          size="lg"
        >
          <MDBCard>
            <MDBCardHeader className="primary-color">
              <h5 className="h5-responsive white-text">
                <MDBIcon icon="shopping-cart" />
                &nbsp;<b>Add Customer Ticket</b>
              </h5>
            </MDBCardHeader>
            <MDBCardBody>
              <AddEditSalesMain
                deployURL={props.deployURL}
                apiServer={props.apiServer}
                code="new"
                apiServerHybrid={props.apiServerHybrid}
                toggleModal={toggleAddEdit}
                refreshGrid={refreshGrid}
              ></AddEditSalesMain>
            </MDBCardBody>
          </MDBCard>

          {/* <AddEditDirectiveDetails toggleModal={toggleAddEdit} code={"newrecord"} directivecode={props.code}  apiServer={props.apiServer} loadDirectivesMain={props.loadDirectivesMain}/> */}
        </MDBModal>

        <ToastContainer
          hideProgressBar={true}
          newestOnTop={true}
          autoClose={2000}
        />
      </form>
    </React.Fragment>
  );
};

export default OpenTransactions;
